//------------------------------------------------------------------------------
//  This code was generated by typescript template tool 'Typewriter'.
//
//  Changes to this file may cause incorrect behavior and will be lost if
//  the code is regenerated.
//------------------------------------------------------------------------------

import { JobDepositView } from "./Dental-DataModel-Models-View-JobDepositView";
import { ProtezView } from "./Dental-DataModel-Models-View-ProtezView";

export class JobDepositViewModel extends JobDepositView  {
    
    protezes: ProtezView[];
}




  
